export default class ScraperBuilder
{

  constructor(builder = {})
  {
    this.scrapable_id = builder.scrapable_id || ''
    this.scrapable_type = builder.scrapable_type || null
    this.type = builder.type || null
    this.handler = builder.handler || null
    this.scraper_payload = builder.scraper_payload || ''
    this.return_type = builder.return_type || ''
  }

  static mutations() {
    return {
      setScrapable: (state, payload) => {
        state.builder.scrapable_id = payload.id
        state.builder.scrapable_type = payload.scrapable_type
        state.builder.type = payload.type
        state.builder.handler = payload.handler
      },
      updateScraperPayload: (state, payload) => state.builder.scraper_payload = payload,
      updateReturnType: (state, payload) => state.builder.return_type = payload,
      clear: (state) => state.builder = new ScraperBuilder()
    }
  }

}